import {MyopMessages} from "./MyopMessages";
import {CleanupHandler, runExecutorCleanup} from "./index.ts";
import {BaseMessageHandler} from "./baseMessageHandler";
import {
    BaseMyopMessage, CleanupMessage, CleanupReplayMessage, CreateRefComponentMessage, EnvelopedMessage,
    InitMessage,
    InitResponse,
    MessageDirection,
    MyopBindMessage,
    MyopBindReplayMessage
} from "../messages";

export class HostedComponent<T = any> {
    send = (message: BaseMyopMessage) => {
        //debugger;
    }

    //onMessageReceived: (msg: IMyopMessage) => void;

    constructor(public id: string, public context?: T) {

    }
}

export interface IMyopSDK {
    init: () => void;

    messageToHost: (message: MyopBindReplayMessage, replayTo?: MyopBindMessage) => void

    supportedHandlers: BaseMessageHandler[];

    handleIncomeMessages: (message: BaseMyopMessage) => void

    components: Record<string, HostedComponent>;
}

// const localHostHandledMessages = [
//     MyopMessages.InitRequest,
//     MyopMessages.InitResponse,
//     //MyopMessages.EnvelopedMessage,
// ]

export abstract class BaseMyopSDK implements IMyopSDK {

    abstract messageToHost: (message: MyopBindReplayMessage, replayTo?: MyopBindMessage) => void;

    abstract supportedHandlers: BaseMessageHandler[];

    messageToHandleAfterInit: BaseMyopMessage[] = [];

    components: Record<string, HostedComponent> = {};

    alwaysPassEnvelopesToHost: boolean = false

    messageCleanupCache: Record<string, CleanupHandler | Promise<CleanupHandler>> | Promise<void> = {};

    handleIncomeMessages(event: any) {
        const eventContent = event.data ? event.data : event.detail;

        if (!eventContent || !eventContent.myop) {
            // not myop marked event 
            return;
        } else {
            let message = eventContent as BaseMyopMessage;

            if (message.direction !== MessageDirection.down) {
                //console.log('message dropped in baseSDK, direction was ', event.data.direction)
                return;
            }

            // if (localHostHandledMessages.includes(message.messageType)) {
            //     debugger;
            //     //TODO : fix direction ? message will not proccess otherwise
            //     window.myop.hostSDK.send(message)
            //     return;
            // }

            if (message.messageType === MyopMessages.DisposeMessage) {
                //debugger;

                //TODO : should not be optional, fix and remove 'if'
                if (message.destination)
                    delete this.components[message.destination]
                return;
            }

            // We got our id from our hostSDK
            if (message.messageType === MyopMessages.InitMessage) {
                //TODO : SDK may serve more than 1 component .. think about that
                // @ts-ignore
                const newComponentId = (message as InitMessage).content.id;

                if (this.components[newComponentId]) {
                    //debugger;
                    //throw new Error("rechived init message for an exsising component.")
                    return;
                }

                this.components[newComponentId] = new HostedComponent(newComponentId)
                this.messageToHost(new InitResponse(newComponentId));

                // TODO : is it true to not pass further ( to the component )
                return;
            }

            // for same HostSDK cases
            // when both RefComponent and realComponent hosted in the same HostSDK
            if (message.messageType === MyopMessages.EnvelopedMessage) {
                const envelopedMessage = (message as EnvelopedMessage);
                const innerMessage = envelopedMessage.message;
                message = innerMessage;

                if (this.alwaysPassEnvelopesToHost || this.components[message.destination!]) {
                    // @ts-ignore
                    const destinationComponent = myop.hostSDK.components.find(c => c.id === innerMessage.destination);
                    if (destinationComponent) {
                        destinationComponent.send(innerMessage);
                        return;
                    }

                    // @ts-ignore
                    const envelopedDestinationComponent = myop.hostSDK.components.find(c => c.id === envelopedMessage.destination);
                    if (envelopedDestinationComponent) {
                        envelopedDestinationComponent.send(innerMessage);
                        return;
                    }
                } else {
                    return;
                }
            }

            // if(message.messageType === MyopMessages.CreateRefComponentMessage){
            //     const typedMessage : CreateRefComponentMessage = message as CreateRefComponentMessage;
            // //    debugger;
            // }
            if (message.messageType) {

                if (message.messageType === MyopMessages.CleanupMessage) {
                    const typedMessage = message as CleanupMessage;
                    const cleanup = this.messageCleanupCache[typedMessage.cleanupForMessageId];

                    const cleanupMessage = new CleanupReplayMessage(!!cleanup);
                    cleanupMessage.destination = message.destination;

                    if (!!cleanup) {
                        delete this.messageCleanupCache[typedMessage.cleanupForMessageId];
                        runExecutorCleanup(cleanup).then(() => {
                            this.messageToHost(cleanupMessage, typedMessage);
                        }).catch(() => {
                            //TODO : handel error?
                        })
                    } else {
                        this.messageToHost(cleanupMessage, typedMessage);
                    }
                    return;
                }

                let actionHandlerFound = false;

                this.supportedHandlers.forEach(handler => {
                    if (handler.messageType === message.messageType) {
                        actionHandlerFound = true;
                        const cleanup = handler.executor(message);

                        if (message.cleanable && cleanup) {
                            this.messageCleanupCache[message.id] = cleanup;
                        }

                        if (cleanup && !message.cleanable) {
                            throw new Error(`Cleanup handler generated for non-cleanable message. 
messageType - ${message.messageType}, handler executor was - ${handler.executor}

Please review the message definition object & message handler.
To ensure cleanup properly set 'cleanable' true at message definition and return IMessageExecutorCleanup from your handlers.`)
                        }

                        if (!cleanup && message.cleanable) {
                            throw new Error(`No cleanup handler generated for a cleanable message. 
messageType - ${message.messageType}, handler executor was - ${handler.executor}

Please review the message definition object & message handler.
To ensure cleanup properly set 'cleanable' true at message definition and return IMessageExecutorCleanup from your handlers.`)
                        }
                    }
                })

                if (!actionHandlerFound) {
                    //TODO : print with debug config only
                    //console.log('no message handler was found for ', message)
                }
            } else {
                console.log('unsupported message type')
            }
        }
    }

    abstract init: () => void;
}
